// extracted by mini-css-extract-plugin
export default {"search":"TradesWidget_search__3tOcf","card":"TradesWidget_card__XU+rh"};